<template lang="pug">
.tournament
  ads
  roomRules
  roomBetList
  roomPlayerBetslip
  router-view
</template>
  
<script>
import config from "@/config";

export default {
  components: {
    ads: () => import("@/views/tournament/components/ads"),
    roomRules: () => import("@/views/tournament/components/roomRules"),
    roomBetList: () => import("@/views/tournament/components/roomBetList.vue"),
    roomPlayerBetslip: () => import("@/views/tournament/components/roomPlayerBetslip.vue"),
  },
  data() {
    return {};
  },
  computed: { },
  destroyed() { },
  mounted() { },
  created() { },
  methods: { }
};
</script>
  